export const styles = {
  root: {
    display: "flex",
    width: "78vw",
    height: "31vh",
    backgroundColor: "#222222",
    border: "none",
    padding: "0px",
    "&:hover": {
      border: "2px solid #28B6CB",
      backgroundColor: "#333333",
    },
    "&:active": {
      border: "2px solid #28B6CB",
      backgroundColor: "#333333",
    },
  } as const,
};
